import { useDispatch } from 'react-redux';
import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import allActions from '../../actions/product_builder';
import buttons from '../../styles/buttons.module.css';
import layout from '../../styles/layout.module.css';

let CategoryExcerpt = ({ currCategory, index, category, summaryState, handleMobileScroll }) => {
    const dispatch = useDispatch();
    const current = currCategory.toUpperCase() === category.displayName;
    const { t } = useTranslation();

    // useEffect(() => {
    //     navContainerRef = document.getElementById('navContainer');

    // }, [currCategory]);

    const handleCategoryClick = () => {
        // For other categories, proceed normally
        dispatch(allActions.categoryActions.setActiveCategory(category.displayName));
        handleMobileScroll(index);
    };

    if (category.displayName === 'SUMMARY' && summaryState === false) {
        return (
            <Box className={layout.contanierCenter}>
                <Button
                    disableRipple={true}
                    className={current ? buttons.btnMenuActive : buttons.btnMenu}
                    disabled
                    onClick={() => {
                        dispatch(
                            allActions.categoryActions.setActiveCategory(category.displayName)
                        );
                    }}>
                    {t('menu.' + category.displayName.toLowerCase())}
                </Button>
            </Box>
        );
    }

    return (
        <>
            <Box className={layout.contanierCenter}>
                <Button
                    disableRipple={true}
                    style={
                        category.displayName === 'CARE_PLAN'
                            ? {
                                  minWidth: '115px',
                                  position: 'relative'
                              }
                            : {}
                    }
                    className={
                        current
                            ? buttons.btnMenuActive +
                              ' ' +
                              (category.displayName === 'CARE_PLAN'
                                  ? buttons.blueShadow
                                  : buttons.blackShadow)
                            : buttons.btnMenu
                    }
                    onClick={handleCategoryClick}>
                    {t('menu.' + category.displayName.toLowerCase())}
                    {category.displayName === 'CARE_PLAN' && (
                        <div className={buttons.newButtonSticker}>
                            <p>New</p>
                        </div>
                    )}
                </Button>
            </Box>
        </>
    );
};

export default CategoryExcerpt;
